export enum RequestActionTypeCd {
  approved = 'APPROVED',
  deEscalate = 'DE_ESCALATE',
  hold = 'HOLD',
  moreInfo = 'MORE_INFO',
  notApproved = 'NOT_APPROVED',
  reSubmit = 'RE_SUBMIT',
  submit = 'SUBMIT',
};
